<template>
    <DefaultLayout header="primary" footer="primary">
        <StatusHeroBanner :message="this.pageData.action_message" />
        <StatusTable />
    </DefaultLayout>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    created() {
        this.emitter.on('pageData:loaded', () => {
            this.emitter.off('pageData:loaded')
        })
    },
    computed: {
        pageData: function () {
            if (this.store.state.global.page) {
                this.emitter.emit('pageData:loaded')
                return this.store.state.global.page
            }

            return null
        },
    },
}
</script>
